import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotfoundComponent } from './shared/component/page-notfound/page-notfound.component';
import { ManageCorporateComponent } from './home/manage-corporate/manage-corporate.component';
import { ManageStaffComponent } from './home/manage-staff/manage-staff.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    // canActivate: [AuthGuard],
  },
  { path: 'managestaff', component: ManageStaffComponent },
  { path: 'manageCorporate', component: ManageCorporateComponent },
  { path: '**', redirectTo: '/pagenotfound' },
  // { path: 'dashboard', component: DashboardComponent },
  // { path: 'manage-inventory', component: ManageInventoryComponent },
  // { path: 'manage-pricing', component: ManagePricingComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
